import { 
    ADD_UNIT_UTILITY, DELETE_UNIT_UTILITY, FETCH_UNIT_UTILITIES, 
    LOG_OUT_USER, UPDATE_UNIT_UTILITY, BULK_CREATE_UTILITY_INVOICES,
    DELETE_INVOICES
 } from "../../actions/actionTypes";


const addUnitUtilityReducer = (unitUtilities, payload) => {
    let newUnitUtilities = { ...unitUtilities};

    newUnitUtilities[payload.utilityId] = {
        ...payload
    };
    return newUnitUtilities;   
}

const updateUnitUtilityReducer = (unitUtilities, payload) => {
    let newUnitUtilities = {...unitUtilities};
    newUnitUtilities[payload.utilityId] = { ...payload };
    return newUnitUtilities;
}

const deleteUnitUtilityReducer = (unitUtilities, payload) => {
    let newUnitUtilities = {...unitUtilities};
    delete newUnitUtilities[payload.utilityId];
    return newUnitUtilities;
}

const fetchUnitUtilityReducer = (unitUtilities, payload) => {
    let newUnitUtilities;
    if (payload.appendData){
        newUnitUtilities = { ...unitUtilities, ...payload.unitUtilities };
    }else{
        newUnitUtilities = { ...payload.unitUtilities };
    }
   
    return newUnitUtilities;
}

const bulkCreateUtilityInvoicesReducer = (unitUtilities, payload) => {
    let newUnitUtilities = {...unitUtilities};
    for(let utility of payload.utilities){
        if(utility.utilityId in newUnitUtilities){
            newUnitUtilities[utility.utilityId] = {
                ...newUnitUtilities[utility.utilityId],
                ...utility
            }
        }
    }
    return newUnitUtilities;
}

const deleteUtilityInvoice = (unitUtilities, payload) => {
    if(payload.success){
        let newUnitUtilities = {...unitUtilities};
        // remove utility reference to deleted invoice
        for(let utilityId of Object.keys(newUnitUtilities)){
            if(payload.invoiceIds.includes(newUnitUtilities[utilityId].invoiceId)){
                newUnitUtilities[utilityId].invoiceId = "";
                newUnitUtilities[utilityId].invoiceAmount = "";
            }
        }
        return newUnitUtilities;
    }else{
        return unitUtilities;
    }
}


const unitUtilitiesReducer = (state={}, action) => {
    let  unitUtilities = state;
    if (action.errors == null){
        switch(action.type){
            case FETCH_UNIT_UTILITIES:
                return fetchUnitUtilityReducer(unitUtilities, action.payload);
            case ADD_UNIT_UTILITY:
                return addUnitUtilityReducer(unitUtilities, action.payload.unitUtility);
            case UPDATE_UNIT_UTILITY:
                return updateUnitUtilityReducer(unitUtilities, action.payload.unitUtility);
            case DELETE_UNIT_UTILITY:
                return deleteUnitUtilityReducer(unitUtilities, action.payload);
            case BULK_CREATE_UTILITY_INVOICES:
                return bulkCreateUtilityInvoicesReducer(unitUtilities, action.payload);
            case DELETE_INVOICES:
                return deleteUtilityInvoice(unitUtilities, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return unitUtilities;
        }
    }else{
        return unitUtilities;
    }
};
export default unitUtilitiesReducer;